import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';

const { Sider } = Layout;

export function AdminSidebar() {
  return (
    <Sider width={200} className="site-layout-background">
      <Menu mode="inline" defaultSelectedKeys={['resellers']} style={{ height: '100%', borderRight: 0 }}>
        <Menu.Item key="resellers">
          <Link to="/resellers">Resellers</Link>
        </Menu.Item>
        <Menu.Item key="packages">
          <Link to="/packages">Packages</Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
}
